<template>
  <icon :width="size" :height="size" :glyph="currentActivityIconGlyph" />
</template>

<script>
import Icon from '@/components/common/Icon.vue';

export default {
  name: 'ActivityIcon',
  props: {
    activity: {
      type: [Number, String],
      required: true,
    },
    size: {
      type: Number,
      required: true,
    },
  },
  components: {
    Icon,
  },
  computed: {
    activityType() {
      return this.$store.state.descriptions.activityType;
    },
    currentActivityIconGlyph() {
      const { activity, activityType } = this;

      return activityType.find(
        (type) => type.description === activity || type.value === activity,
      ).logoKey;
    },
  },
};
</script>
